import { FaBoxOpen, FaDatabase, FaFileInvoiceDollar, FaGear, FaHexagonNodes, FaHouse, FaLifeRing, FaMoneyBillWave, FaUserGear, FaWifi } from "react-icons/fa6";

export const NavLinkItemMitra = [
  { id: 1, name: "Dashboard", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  {
    id: 2, name: "Master Data", icon: FaDatabase, type: "accordion",
    subItems: [
      { id: 2.1, name: "NAS", path: "/dashboard/master-data/nas" },
      { id: 2.2, name: "POP", path: "/dashboard/master-data/pop" },
      { id: 2.3, name: "ODC", path: "/dashboard/master-data/odc" },
      { id: 2.4, name: "ODP", path: "/dashboard/master-data/odp" },
    ],
  },
  {
    id: 3, name: "PPPoE", icon: FaWifi, type: "accordion",
    subItems: [
      { id: 3.1, name: "Profile", path: "/dashboard/pppoe/profile" },
      { id: 3.2, name: "User", path: "/dashboard/pppoe/user" },
      { id: 3.3, name: "PSB", path: "/dashboard/pppoe/psb" },
    ],
  },
  {
    id: 4, name: "Hotspot", icon: FaHexagonNodes, type: "accordion",
    subItems: [
      { id: 4.1, name: "Profile", path: "/dashboard/hotspot/profile" },
      { id: 4.2, name: "User", path: "/dashboard/hotspot/user" },
      { id: 4.3, name: "PSB", path: "/dashboard/hotspot/psb" },
    ],
  },
  { id: 8, name: "Invoice", icon: FaFileInvoiceDollar, path: "/dashboard/invoice", type: "link" },
  { id: 9, name: "Tiket Gangguan", icon: FaLifeRing, path: "/dashboard/ticket", type: "link" },
  { id: 12, name: "Pengaturan", icon: FaGear, path: "/dashboard/setting", type: "link" },
];